export interface ExpectedStocks {
  stockName: string;
  investingAmount: number;
  stockPrice: number;
  purchasedStocks: number;
  averagePrice: number;
}

export interface ReckonExpectedStocks {
  stockName: string;
  totalStockPurchased: number;
  totalAveragePrice: number;
  totalInvestedPrice: number;
  totalStockInvested: number;
  totalInvestingAmount: number;
}

export interface InitStocksState {
  expectedStocks: ExpectedStocks;
  showStocksAveragePrice: boolean;
  reckonExpectedStocks: ReckonExpectedStocks[];
}

export const initialStocksState: InitStocksState = {
  expectedStocks: null,
  showStocksAveragePrice: false,
  reckonExpectedStocks: [],
};
